// @flow
import React, { type Node } from 'react';
import styled from 'styled-components';
import lightbulbSrc from './lightbulb-icon.svg';

export function MulticajaInfo(): Node {
  return (
    <>
      <MulticajaTips />
      <OtherMethodsInformation />
    </>
  );
}

function MulticajaTips(): Node {
  return(
    <TipsWrapper>
      <li>Serás direccionado a la plataforma de Klap (Multicaja) para generar tu voucher.</li>
      <li>Klap (Multicaja) enviará tu voucher al email registrado en la plataforma y <b>tendrás hasta 3 dias </b> para realizar tu pago.</li>
    </TipsWrapper>
  );
}


function OtherMethodsInformation(): Node {
  return (
    <InformationWrapper>
      <LightBulbIcon />
      <InformationText>
        En caso de no poder realizar tu pago con el método que elegiste,
        tendrás siempre la opción de generar un nuevo pedido con: Webpay, ServiPag y Sencillito.
      </InformationText>
    </InformationWrapper>
  );
}

const TipsWrapper = styled.ul`
  padding: 0 30px;
`;

function LightBulbIcon(): Node {
  return <LightBulbImage src={lightbulbSrc} alt="light bulb icon"/>;
}

const InformationText = styled.div`
text-align: left;
font-size: 12px;
font-family: ${props => props.theme.fontFamily.sansSerif};
color: #2f4a75;
display: inline-block;
`;

const InformationWrapper = styled.div`
background-color: ${props => props.theme.colors.primary('96')};
color: ${props => props.theme.colors.primary('32')};
display: flex;
align-items: center;
padding: 5px;
`;

const LightBulbImage = styled.img`
background-color: ${props => props.theme.colors.primary('40')};
display: inline-block;
width: 28px;
padding: 5px;
border-radius: 10px;
margin: 15px;
`;
